$(document).ready(function(e){
  console.log(
  "%cCustom JS is ready",
  "background: linear-gradient(to right, #EB9BA3, #000000); color: #FFF; font-weight: bold; font-size: 50px;"
);

   //Index_4 slider
    $('.index4-slide').slick({
   dots: false,
   arrows:true,
   infinite: true,
   speed: 300,
   slidesToShow: 4,
   slidesToScroll: 1,
   adaptiveHeight: false,
    prevArrow:"<div  class='slick-prev pull-left'><svg xmlns='http://www.w3.org/2000/svg' width='17' height='30' viewBox='0 0 17 30' fill='none'><path d='M16 1L2 15L16 29' stroke='white' stroke-width='2'/></svg></div>",
    nextArrow:"<div  class='slick-next pull-right'><svg xmlns='http://www.w3.org/2000/svg' width='17' height='30' viewBox='0 0 17 30' fill='none'><path d='M1 1L15 15L1 29' stroke='white' stroke-width='2'/></svg></div>",  
   responsive: [
     {
       breakpoint: 1024,
       settings: {
         slidesToShow: 3,
         slidesToScroll: 3,
         infinite: true,
         arrrow:true
       }
     },
     {
       breakpoint: 600,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 2,
         arrrow:true
       }
     },
     {
       breakpoint: 480,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 1,
         arrrow:true
       }
     }
   ]
 });

//index 6 slider

$('.index6-slide').slick({
   dots: false,
   arrows:true,
   infinite: true,
   speed: 300,
   slidesToShow: 4,
   slidesToScroll: 1,
   adaptiveHeight: false,
  prevArrow:"<div  class='slick-prev pull-left'><svg xmlns='http://www.w3.org/2000/svg' width='17' height='30' viewBox='0 0 17 30' fill='none'><path d='M16 1L2 15L16 29' stroke='white' stroke-width='2'/></svg></div>",
    nextArrow:"<div  class='slick-next pull-right'><svg xmlns='http://www.w3.org/2000/svg' width='17' height='30' viewBox='0 0 17 30' fill='none'><path d='M1 1L15 15L1 29' stroke='white' stroke-width='2'/></svg></div>",
   responsive: [
     {
       breakpoint: 1024,
       settings: {
         slidesToShow: 3,
         slidesToScroll: 1,
         infinite: true,
         arrrow:true
       }
     },
     {
       breakpoint: 600,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 1,
         arrrow:true
       }
     },
     {
       breakpoint: 480,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 1,
         arrrow:true
       }
     }
   ]
 });


// PressEX system page testimonial slider

 $('.revslider').slick({
            slidesToShow: 5,
            arrows: true,
            dots: false,
            autoplay: false,
            responsive: [
              {
                breakpoint: 1367,
                settings: {
                  slidesToShow: 4
                }
              },
              {
                breakpoint: 1025,
                settings: {
                  slidesToShow: 3
                }
              },
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 2
                }
              },
              {
                breakpoint: 481,
                settings: {
                  slidesToShow: 1
                }
              }
            ]
          });
        
  
// for FAQ

$(function() {
$('.accordion .acc-headng-main').click(function(){
$(this).parent().toggleClass(' active ');
$(this).parent().siblings().removeClass('active');

$(this).parent().children(".content-box").toggleClass('open').slideToggle();
$(this).parent().siblings().children(".content-box").removeClass('open').slideUp();
return false;
});
});




  
//for product page terms & condition

//  $('.product-form__submit').prop('disabled', true);
//  $('#termsCheckbox').on('change', function () {
//    if ($(this).prop('checked')) {
//      $('.product-form__submit').prop('disabled', false);
//    } else {
//      $('.product-form__submit').prop('disabled', true);
//    }
//  });

         //product page show more toggle


$('#show-more-content').hide();
$('#show-less').hide();  
$('#show-more').click(function(){
	$('#show-more-content').show(300);
	$('#show-less').show();
	$('#show-more').hide();
});

$('#show-less').click(function(){
	$('#show-more-content').hide(150);
	$('#show-more').show();
	$(this).hide();
});






  
  
        // Get references to the button and div
 //       var toggleButton = document.getElementById('toggleButton');
 //       var myDiv = document.getElementById('myDiv');

        // Add a click event listener to the button
//        toggleButton.addEventListener('click', function () {
//            if (myDiv.style.display === 'none' || myDiv.style.display === '') {
//                myDiv.style.display = 'block';
//            } else {
//                myDiv.style.display = 'none';
 //           }
 //       });





 //    $('.hidden-video').hide();
    // Attach a click event handler to anchor tags with class 'toggle-video'
//    $('.toggle-video').on('click', function () {
      // Find the closest '.index4Sec-videowrp' within the same parent element
//      var videoWrapper = $(this).closest('.indexSec4-holder').find('.index4Sec-videowrp');

      // Toggle the visibility of the video wrapper
//      videoWrapper.toggle();
//    });



  

  

});